import React, { Suspense, useState } from "react";
// @material
import { Stack } from "@mui/material";
// components
import AssetViewerTable from "./AssetListViewer/AssetTable";
import AssetViewerHeader from "./Header/Title";
import AssetViewerTabs from "./Tabs";
import Page from "@components/Page";
import LoadingScreen from "@components/LoadingScreen";
import { SideBar } from "../../comparison/SideBar";
import { PageTitle } from "@components/ui/styles";

// ----------------------------------------------------------------------

function AssetOperationsPage() {
  const [checkedAssets, setCheckedAsset] = useState<Array<Object>>([]);

  return (
    <>
      <Page title="지수 종목 탐색">
        <Stack spacing={2}>
        <PageTitle>지수 종목 탐색</PageTitle>
          <AssetViewerTable
            onSelectAsset={(e) => {
              setCheckedAsset([e, ...checkedAssets]);
            } } onChangeChecked={()=> {}}          />
          <Suspense fallback={<LoadingScreen />}>
            <AssetViewerHeader />
            <AssetViewerTabs />
          </Suspense>
        </Stack>
        <SideBar
          assetType="index"
          market="global"
          checkedAssets={checkedAssets.map((v) => {
            // 장바구니가 assetId 로 중복을 거른다. 없으면 한 종목만 남는다.
            return { ...v, assetId: v["rf_id"], name: v["종목명"] };
          })}
          onChange={setCheckedAsset}
        />
      </Page>
    </>
  );
}

export default React.memo(AssetOperationsPage);
